var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["./personal-info-edit.j2"] = require( "./personal-info-edit.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["account/templates/partials/basics-email.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"c-profile__h2-outer\">\n\n    <h2 class=\"c-profile__h2\">\n\n        ";
output += runtime.suppressValue((lineno = 4, colno = 9, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["account_accountSettings-editPersonalInformation",runtime.makeKeywordArgs({"state": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "state")),"core")})])), env.opts.autoescape);
output += "\n\n    </h2>\n\n</div>\n\n";
if((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "v")),"viewStates")),"focusValue") == "basics" || runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "v")),"viewStates")),"focusValue") == "password") && runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "v")),"viewStates")),"showErrors")) {
output += "\n\n    <div class=\"c-form__field has-error\">\n\n        <div class=\"c-form-block\">\n\n            <p class=\"c-form-block__p\" data-qa-account-edit-error>\n\n                ";
output += runtime.suppressValue(runtime.memberLookup(((lineno = 18, colno = 27, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "Profile")),"get"), "Profile[\"get\"]", context, ["errors"]))),"data"), env.opts.autoescape);
output += "\n\n            </p>\n\n        </div>\n\n    </div>\n\n";
;
}
output += "\n\n";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "v")),"viewStates")),"personalInfoEdit") == false) {
output += "\n\n    <p class=\"c-profile__p--edit\">\n\n        <div class=\"u-line u-margin-bottom--extra-small\">\n\n            <span class=\"u-global-h5\">\n                ";
output += runtime.suppressValue((lineno = 35, colno = 17, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["account_accountSettings-firstName",runtime.makeKeywordArgs({"state": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "state")),"core")})])), env.opts.autoescape);
output += ":\n            </span>\n\n            ";
if(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "Profile")),"profile")),"name")),"first") == "") {
output += "\n\n            <span class=\"u-text-details\">\n                ";
output += runtime.suppressValue((lineno = 41, colno = 17, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["account_profile_undefined-attribute",runtime.makeKeywordArgs({"state": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "state")),"core")})])), env.opts.autoescape);
output += "\n            </span>\n\n            ";
;
}
else {
output += "\n\n            <span data-qa-account-info-first-name>\n                ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "Profile")),"profile")),"name")),"first"), env.opts.autoescape);
output += "\n            </span>\n\n            ";
;
}
output += "\n\n        </div>\n\n        <div class=\"u-line u-margin-bottom--extra-small\">\n\n            <span class=\"u-global-h5\">\n                ";
output += runtime.suppressValue((lineno = 57, colno = 17, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["account_accountSettings-lastName",runtime.makeKeywordArgs({"state": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "state")),"core")})])), env.opts.autoescape);
output += ":\n            </span>\n\n            ";
if(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "Profile")),"profile")),"name")),"last") == "") {
output += "\n\n            <span class=\"u-text-details\">\n                ";
output += runtime.suppressValue((lineno = 63, colno = 17, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["account_profile_undefined-attribute",runtime.makeKeywordArgs({"state": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "state")),"core")})])), env.opts.autoescape);
output += "\n            </span>\n\n            ";
;
}
else {
output += "\n\n            <span data-qa-account-info-last-name>\n                ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "Profile")),"profile")),"name")),"last"), env.opts.autoescape);
output += "\n            </span>\n\n            ";
;
}
output += "\n\n        </div>\n\n        <div class=\"u-line\">\n\n            <span class=\"u-global-h5\" data-qa-account-settings-email>\n                ";
output += runtime.suppressValue((lineno = 79, colno = 17, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["account_accountSettings-email",runtime.makeKeywordArgs({"state": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "state")),"core")})])), env.opts.autoescape);
output += ":\n            </span>\n\n            <span data-qa-account-settings-email>\n                ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "Profile")),"profile")),"emailAddress"), env.opts.autoescape);
output += "\n            </span>\n\n        </div>\n\n    </p>\n\n";
;
}
output += "\n\n";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "v")),"viewStates")),"personalInfoEdit") == true) {
output += "\n\n    ";
env.getTemplate("./personal-info-edit.j2", false, "account/templates/partials/basics-email.j2", null, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
t_1.render(context.getVariables(), frame, function(t_4,t_2) {
if(t_4) { cb(t_4); return; }
output += t_2
output += "\n\n";
})});
}
else {
output += "\n\n    <p class=\"c-profile__p\">\n\n        <a class=\"c-profile__button--edit js-account-personal-info-edit\" href=\"";
output += runtime.suppressValue((lineno = 100, colno = 80, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["account_edit",runtime.makeKeywordArgs({"state": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "state")),"core")})])), env.opts.autoescape);
output += "\" data-cm-element=\"account-edit-basics\" data-qa-account-edit>\n\n            ";
output += runtime.suppressValue((lineno = 102, colno = 13, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["account_accountSettings-edit",runtime.makeKeywordArgs({"state": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "state")),"core")})])), env.opts.autoescape);
output += "\n\n        </a>\n\n    </p>\n\n";
;
}
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["account/templates/partials/basics-email.j2"] , dependencies)